import { FilterInput, SortInput, SupportedSortBy } from '@apeiron/common'
import { deserializeData } from '@apeiron/temp'
import { ApolloError, useMutation } from '@apollo/client'
import { FavoriteType } from '@src/constants/favoriteFilter'
import { favoriteFilterSchema } from '@src/deserialize/yup/favoriteFilter'
import graphql from '@src/graphql/mutation/createFavoriteFilter'
import { FavoriteFilter } from '@src/types/favoriteFilter'
import { useCallback, useState } from 'react'

const useCreateFavoriteFilter = (): Hook => {
  const [createFavoriteFilter, { loading, error }] = useMutation(graphql)

  const [data, setData] = useState<Response>(null)

  const mutate = useCallback(
    async (request: Request): Promise<Response> => {
      const { name, filterInput, sortInput, type } = request

      const response = await createFavoriteFilter({
        variables: {
          filterInput: JSON.stringify(filterInput),
          name,
          type,
          sortInput: JSON.stringify(sortInput)
        }
      })

      const result = deserializeData<FavoriteFilter<FilterInput>>(
        response,
        favoriteFilterSchema
      )

      setData(result)

      return result
    },
    [createFavoriteFilter]
  )

  return {
    mutate,
    data,
    loading,
    error
  }
}

type Request = {
  filterInput?: FilterInput
  name: string
  sortInput?: SortInput<SupportedSortBy>
  type: FavoriteType
}

type Response = FavoriteFilter<FilterInput> | null

type Hook = {
  mutate: (request: Request) => Promise<Response>
  data: Response
  loading: boolean
  error: ApolloError | undefined
}

export default useCreateFavoriteFilter
